export const ERROR_MAP = {
  INVALID_CODE: {
    icon: '❌',
    title: 'QR Code Invalide',
  },
  UNAUTHENTICATED: {
    icon: '🔒',
    title: 'Non authentifié',
  },
  NO_ACCESS: {
    icon: '🚫',
    title: 'Accès refusé',
  },
  OUT_OF_ZONE: {
    icon: '📍',
    title: 'Hors zone autorisée',
  },
  ALREADY_COMPLETE: {
    icon: '⏰',
    title: 'Pointage déjà effectué',
  },
  DEFAULT: {
    icon: '⚠️',
    title: 'Erreur de scan',
  },
};